import React from 'react';

const faqs = [
  {
    sectionTitle: 'General',
    sectionFaqs: [
      {
        question: 'What is a hackathon?',
        answer: [
          <p>A hackathon is a collaborative event in which teams learn new skills &amp; technologies and create projects. There’s prizes to win, workshops on various fields in Computer Science, and other fun mini-events to take part in! This year, HackIllinois will be a 36-hour virtual hackathon, meaning that attendees from around the world can attend from the comfort of their home.</p>,
        ],
      },
      {
        question: 'When and where is HackIllinois?',
        answer: [
          <p>HackIllinois will be held from February 25-27th virtually on a Discord Server through which attendees can ask questions and interact with one another.</p>,
        ],
      },
      {
        question: 'How do I register?',
        answer: [
          <p>Here is the link to register: <a href="https://hackillinois.org/register">https://hackillinois.org/register</a>. Interested participants can register until the day of the event, February 25, 2022.</p>,
        ],
      },
      {
        question: 'Who can register?',
        answer: [
          <p>Anyone 18 years or older and enrolled in a high school, college, or university (or left school during the current school year) can register!</p>,
        ],
      },
    ],
  },
  {
    sectionTitle: 'Before the Event',
    sectionFaqs: [
      {
        question: 'Do I need a team? How do I find one?',
        answer: [
          <p>No, you are not required to have a team to participate. With that being said, we strongly encourage you to work with other participants in order to get the full experience at HackIllinois. You can make teams prior to the event or find members through our team matching event (As part of Hackathons Crash Course/Hackathons 101) or on the Discord.</p>,
        ],
      },
      {
        question: 'What should I bring?',
        answer: [
          <p>Nothing! Everything will be online!</p>,
        ],
      },
      {
        question: 'Will there be food?',
        answer: [
          <p>Unfortunately, we won’t be able to provide meals or meal vouchers as our event is fully virtual.</p>,
        ],
      },
      {
        question: 'Do I need to have a programming background to participate?',
        answer: [
          <p>No! People of all skill levels are welcomed!</p>,
        ],
      },
    ],
  },
  {
    sectionTitle: 'Day of Event',
    sectionFaqs: [
      {
        question: 'Is there anything to do other than code?',
        answer: [
          <p>Yes! There will be a variety of mini-events, workshops, and company events for attendees to join. You should definitely check out the schedule that will be posted here on the website!</p>,
        ],
      },
      {
        question: 'How can I stay updated with what is going on at the event?',
        answer: [
          <p>Please download the HackIllinois app (available shortly before the event on the App Store and Play Store)! Our website will also be continually updated with new information throughout the year. We will also be sending out reminders for various workshops and events on our Discord. Once you register, you’ll receive instructions on how to RSVP and join the Discord server.</p>,
        ],
      },
      {
        question: 'Have more questions?',
        answer: [
          <p>Please don’t hesitate to reach out to us at <a href="mailto:contact@hackillinois.org">contact@hackillinois.org</a> if you have any other questions!</p>,
        ],
      },
    ],
  },
];

export default faqs;
